import { useTranslation } from 'react-i18next';
import { ContentPage } from '../page-factory/content-page';
import { whoWeArePage } from '../pages/page-magh-mela';
import { getPageMeta } from '../pages/pages-types';
import { MetaFunction } from '@remix-run/cloudflare';

export const meta: MetaFunction = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation(['home', 'common']);
  return getPageMeta(whoWeArePage, t);
};

export default function WhoWeAre() {
  return <ContentPage {...whoWeArePage} />;
}
